import { z } from 'zod';
import { supportedLocales } from '@/i18n/i18n';

export const userOnboardingSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  language: z.enum(supportedLocales),
  essentialCookiesAccepted: z.boolean().refine((v) => v === true, { message: 'essential_cookies_required' }),
});
